export const HieGetDocumentsBlockDocumentationMarkdown = `
# HIE Get Documents

Get patient documents from the HIE. This block must be used in conjunction with an HIE Query Documents block.

## Limitations

### Concurrent runs for the same patient can interfere
Running this block for the **same patient** in more than one flow at the same time can cause the runs to interfere with each other. The HIE delivers documents per-patient rather than per-request, so when multiple runs are in flight for the same patient they end up competing for the same delivery — only one run will complete correctly, and the others may finish with incorrect or missing documents.

* This applies across flow runs and across agents — two flows that touch the same patient at the same time will collide.
* Different patients are unaffected and run fully in parallel.

## Errors

### \`Did not receive signal for block within timeout\`
The block waited the full configured timeout without ever receiving a callback from the HIE. The most common cause is concurrent runs for the same patient (see the limitation above) — when multiple runs are in flight, only one receives a usable callback. Other possible causes include the HIE being slow or unavailable, or the configured timeout being too short for the volume of documents being retrieved.
`;
